import DatasetSegmentForm from '../app/Dashboard/Datasets/DatasetSegmentForm';
import DatasetURLsWhitelistForm from '../app/Dashboard/Datasets/DatasetURLsWhitelistForm';

const components = {
    Datasets: {
        addSegment: DatasetSegmentForm,
        editSegment: DatasetSegmentForm,
        duplicateSegment: DatasetSegmentForm,
        createURLsWhitelist: DatasetURLsWhitelistForm,
        editURLsWhitelist: DatasetURLsWhitelistForm,
    },
};

const datasets = {
    path: "/datasets",
    key: "datasets",
};

let datasetConstants = [];
let currentComponent = components["Datasets"];
let keys = Object.keys(currentComponent);
keys.forEach(key => {
    datasetConstants.push({
        path: `${datasets.path}/${key}`,
        text: "Datasets",
        component: currentComponent[key]
    });
});

export default datasetConstants;